import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.userInteracted = false
    this.hasScrolled = false
    this.hasCorrected = false
    this.correctionTimer = null
    this.markUserInteraction = this.markUserInteraction.bind(this)
    this.correctAfterAssets = this.correctAfterAssets.bind(this)

    window.addEventListener("wheel", this.markUserInteraction, { passive: true, once: true })
    window.addEventListener("touchstart", this.markUserInteraction, { passive: true, once: true })
    window.addEventListener("pointerdown", this.markUserInteraction, { passive: true, once: true })
    window.addEventListener("keydown", this.markUserInteraction, { once: true })
    window.addEventListener("load", this.correctAfterAssets, { once: true })

    requestAnimationFrame(() => {
      this.scrollToResults()
      this.hasScrolled = true
      this.correctionTimer = window.setTimeout(this.correctAfterAssets, 350)
    })
  }

  disconnect() {
    window.removeEventListener("wheel", this.markUserInteraction)
    window.removeEventListener("touchstart", this.markUserInteraction)
    window.removeEventListener("pointerdown", this.markUserInteraction)
    window.removeEventListener("keydown", this.markUserInteraction)
    window.removeEventListener("load", this.correctAfterAssets)
    window.clearTimeout(this.correctionTimer)
  }

  markUserInteraction() {
    this.userInteracted = true
    window.clearTimeout(this.correctionTimer)
  }

  correctAfterAssets() {
    if (!this.hasScrolled || this.hasCorrected || this.userInteracted) return

    this.hasCorrected = true
    this.scrollToResults()
  }

  scrollToResults() {
    if (this.userInteracted || !this.element.isConnected) return

    const headerHeight = document.querySelector("[data-site-header]")?.getBoundingClientRect().height || 0
    const target = this.element.querySelector(".recipe-listing-toolbar") || this.element
    const targetTop = target.getBoundingClientRect().top
    const desiredTop = headerHeight

    if (Math.abs(targetTop - desiredTop) <= 4) return

    const scrollTop = Math.max(window.scrollY + targetTop - desiredTop, 0)
    const root = document.documentElement
    const previousScrollBehavior = root.style.scrollBehavior
    root.style.scrollBehavior = "auto"
    window.scrollTo({
      top: scrollTop,
      behavior: "auto",
    })
    requestAnimationFrame(() => { root.style.scrollBehavior = previousScrollBehavior })
  }

}
